"use strict";

var animationDuration = 3000;
var frameDuration = 1000 / 60;
var totalFrames = Math.round(animationDuration / frameDuration);
var easeOutQuad = function easeOutQuad(t) {
  return t * (2 - t);
};

// eslint-disable-next-line no-unused-vars
var animateCountUp = function animateCountUp(el) {
  var frame = 0;
  var countTo = parseInt(el.getAttribute("target"), 10);
  var currentValue = parseInt(el.innerHTML);
  if (currentValue > 0) {
    return;
  }
  var counter = setInterval(function () {
    frame++;
    var progress = easeOutQuad(frame / totalFrames);
    var currentCount = Math.round(countTo * progress);
    if (parseInt(el.innerHTML, 10) !== currentCount) {
      el.innerHTML = currentCount;
    }
    if (frame === totalFrames) {
      clearInterval(counter);
    }
  }, frameDuration);
};
//# sourceMappingURL=countUp.js.map